import React, { useState, useEffect } from "react";
import CustomerSupportAside from "./CustomerSupportAside";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_BASE = "https://cleezoclass.com:8443/api";

function CustomerSupportCentralization() {
  const [schoolDetails, setSchoolDetails] = useState([]);
  const [schoolDetailsLoading, setSchoolDetailsLoading] = useState(false);
  const [schoolDetailsError, setSchoolDetailsError] = useState("");
  const [schoolFilter, setSchoolFilter] = useState(""); //To filetr the school name
  const [adminFilter, setAdminFilter] = useState("");
  const [phoneFilter, setPhoneFilter] = useState("");
  //   const [search, setSearch] = useState("");



  const navigate = useNavigate(); // to navigate the centralization page

  useEffect(() => {
    setSchoolDetailsLoading(true);

    axios
      .get(`${API_BASE}/reports/centralization`)
      .then((response) => {
        setSchoolDetails(response.data);
      })
      .catch((error) => {
        console.error(error);
        setSchoolDetailsError("Failed to load school details");
      })
      .finally(() => {
        setSchoolDetailsLoading(false);
      });
  }, []);

  console.log(schoolDetails);

  const handleCentralization = (schoolId) => {
    navigate(`/customer-support/centralization/${schoolId}`);
  };

  const [search, setSearch] = useState("");

  const filteredSchools = schoolDetails.filter((school) =>
    school.institute_name?.toLowerCase().includes(search.toLowerCase()) ||
    school.institute_authorized_person?.toLowerCase().includes(search.toLowerCase()) ||
    String(school.institute_contact_number).includes(search)
  );

  return (
    <div className="mainBlock">
      <h2>Customer Support Exicutive</h2>
      <CustomerSupportAside />
      <div className="cust-spt-conatiner">
        <h1>Centralisation</h1>
        <div>
          {schoolDetailsLoading && <p>Loading school details...</p>}
          {schoolDetailsError && (
            <p className="error-message">{schoolDetailsError}</p>
          )}
          <div
            style={{
              display: "flex",
              gap: "10px",
              // marginBottom: "15px",
              justifyContent: "flex-start",
            }}
          >
            <input
              className="cse-filter-input"
              type="text"
              placeholder="Search school, admin, or phone..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

          </div>
          <button
            className="centralization-btn"
            onClick={() => handleCentralization()}
          >
            Open
          </button>
          <table className="sales-performance-table">
            <thead>
              <tr>
                <th>School Name</th>
                <th>Admin</th>
                <th>Admin Number</th>
                <th>UserName</th>
                <th>Password</th>
                {/* <th>Centralisation</th> */}
              </tr>
            </thead>
            <tbody>
              {/* <tr><td><button onClick={()=>handleCentralization()}>Open</button></td></tr> */}

              {filteredSchools.map((school) => (
                <tr key={school.schoolId}>
                  <td>{school.institute_name}</td>
                  <td>{school.institute_authorized_person}</td>
                  <td>{school.institute_contact_number}</td>
                  <td>{school.quality_username}</td>
                  <td>{school.password}</td>
                  {/* <td>                
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default CustomerSupportCentralization;
